<template>
  <div class="waiting">{{ this.$t("default.waiting") }}</div>
</template>

<script>
export default {
  name: "Waiting"
};
</script>

<style scoped lang="scss">
.waiting {
  font-size: 1.25rem;
}
</style>
